var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionnaireBr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "326px",
    height: "15px",
    viewBox: "0 0 326 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B3\\u30FC\\u30B9\\u8A73\\u7D309",
    transform: "translate(-244.000000, -2387.000000)",
    stroke: "#006EA3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "article-/-course-/-detail-copy",
    transform: "translate(213.000000, 1618.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30D7\\u30EC\\u30D3\\u30E5\\u30FC",
    transform: "translate(10.000000, 45.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30A2\\u30F3\\u30B1\\u30FC\\u30C8\\u5185\\u5BB9",
    transform: "translate(21.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3-Copy-3",
    points: "0 704.5 152 704.5 162.5 718 173 704.5 326 704.5"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionnaireBr);
export default __webpack_public_path__ + "static/media/questionnaire-br.4baa7942ff5eeb5ddbe242e49dd5d9bd.svg";
export { ForwardRef as ReactComponent };